/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agents_Command_TitleInputs */

const en_directory_agents_command_title = /** @type {(inputs: Directory_Agents_Command_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One command`)
};

const zh_directory_agents_command_title = /** @type {(inputs: Directory_Agents_Command_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一条命令`)
};

/**
* | output |
* | --- |
* | "One command" |
*
* @param {Directory_Agents_Command_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agents_command_title = /** @type {((inputs?: Directory_Agents_Command_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agents_Command_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agents_command_title(inputs)
	return zh_directory_agents_command_title(inputs)
});
export { directory_agents_command_title as "directory.agents.command_title" }